<template>
  <div>
    <PaginatedTable
      :fields="fields"
      :searchFilters="searchFilters"
      :initialSortBy="'activeDate'"
      :initialSortDesc="true"
      noResultsText="No Notifications for this search."
      tableId="searchListTable"
      url="/notification/search"
    >
      <template v-slot:cell(town)="data">
        {{data.value.name}}, {{data.value.countyName}}
      </template>
      <template v-slot:cell(activeDate)="data">
        {{data.item.activeDate | dateString}}
      </template>
      <template v-slot:cell(harvester)="data">
        {{data.item.harvesterName}}
      </template>
      <template v-slot:cell(notifier)="data">
        {{data.item.notifierName}}
      </template>
      <template v-slot:cell(view)="data">
        <div v-if="shouldShowViewLink(data)" class="text-right">
          <router-link tag="a" size="sm" :to="`/notification/${data.item.id}`">View</router-link>
        </div>
      </template>
    </PaginatedTable>
    <b-modal
      id="view-user-modal"
      footer-class="text-center"
      centered
      title="User Info"
      hide-header-close
      size="md"
    >
      <ContactDetails :contact="currentUser" :disableRemove="true" :showAll="true" :lineBreak="true">
        <ContactDetailLine v-if="currentUser && currentUser.forestProtectionUnitId"
          :lineBreak="true"
          label="Call Number:"
          :value="currentUser.forestProtectionUnitId"
        />
      </ContactDetails>
      <div slot="modal-footer" class="d-flex full-width">
        <b-button
          pill
          variant="primary"
          @click="$bvModal.hide('view-user-modal')"
          aria-label="Close user info modal"
        >Ok</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import PaginatedTable from '@/components/common/PaginatedTable.vue';
import ContactDetails from '@/components/account/ContactDetails.vue';

export default {
  name: 'SearchNotifications',
  props: {
    searchFilters: {
      type: Array,
    },
  },
  components: {
    PaginatedTable,
    ContactDetails,
  },
  computed: {
    ...mapGetters('User', ['mfsAdmin', 'mfsUser']),
    ...mapState(['isExtraSmall']),
    ...mapState('Admin', {
      currentUser: state => state.user,
      loading: state => state.loading,
    }),
    roles: state => state.roles,
  },
  data() {
    return {
      fields: [],
    };
  },
  watch: {
    isExtraSmall() {
      if (this.isExtraSmall) {
        // move actionField in front of basic fields
        this.shiftMobile();
      } else {
        // move actionField to end of basic fields
        const actionField = this.fields.shift();
        this.fields.push(actionField);
      }
    },
  },
  methods: {
    shiftMobile() {
      const actionField = this.fields.pop();
      this.fields.unshift(actionField);
    },
    shouldShowViewLink(data) {
      const shouldShowViewLink = this.mfsAdmin
        || data.item.statusName === 'Active'
        || data.item.statusName === 'Active - Amended'
        || data.item.statusName === 'Closed';
      return shouldShowViewLink;
    },
    async showUserModal(userId) {
      await this.$store.dispatch('Admin/getUser', userId);
      this.$bvModal.show('view-user-modal');
    },
  },
  created() {
    if (this.isExtraSmall) {
      // move actionField in front of basic fields
      this.shiftMobile();
    }
  },
  mounted() {
    if (this.mfsAdmin) {
      this.fields = [
        { key: 'town', label: 'Town', sortable: true },
        { key: 'statusName', label: 'Status', sortable: true },
        { key: 'fonNumber', label: 'FON Number', sortable: true },
        { key: 'notifier', label: 'Notifier', sortable: true },
        { key: 'activeDate', label: 'Active Date', sortable: true },
        { key: 'view', label: '', stickyColumn: true },
      ];
    } else {
      this.fields = [
        { key: 'town', label: 'Town', sortable: true },
        { key: 'statusName', label: 'Status', sortable: true },
        { key: 'fonNumber', label: 'FON Number', sortable: true },
        { key: 'harvester', label: 'Harvester', sortable: true },
        { key: 'activeDate', label: 'Active Date', sortable: true },
        { key: 'view', label: '', stickyColumn: true },
      ];
    }
  },
};
</script>
